import React from "react";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  actionGroup: {
    display: "flex",
    alignItems: "center",
    "& > :first-child": {
      borderTopLeftRadius: theme.custom.defaultBorderRadius * 2,
      borderBottomLeftRadius: theme.custom.defaultBorderRadius * 2,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    "& > :not(:first-child):not(:last-child)": {
      borderRadius: 0
    },
    "& > :last-child": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: theme.custom.defaultBorderRadius * 2,
      borderBottomRightRadius: theme.custom.defaultBorderRadius * 2
    }
  }
}));
function ActionGroup({ children }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: classes.actionGroup }, children);
}
export {
  ActionGroup
};
//# sourceMappingURL=ActionGroup.js.map
